import { render } from "./index.vue?vue&type=template&id=c866a25c"
const script = {}

import exportComponent from "/Users/khatanbaatarb/Documents/projects/roadpay.mn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__